import { API_URL } from '../config/config';
import { getRequest } from '../utils/axiosUtils';
import buildQueryParams from '../utils/buildQueryParams';

export const fetchCountryData = async (filter, setRegionsData, setData) => {
  const { country, state, city, dateRange, gender,utm_payload, isBot, locationStatsType } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
    isBot,
    statsType: locationStatsType
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/userCountryCount?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    let data = [['Country', 'User']];
    const regionsData = res.data.data.countryStats
      .map((item) => {
        if (item && item.country !== null && item.country != '1') {
          data.push([item.country, item.userCount]);
          return {
            name: item.country,
            users: item.userCount,
          };
        }
      })
      .filter((item) => item !== null);

    setRegionsData(regionsData);
    setData(data);
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};

export const fetchRegionData = async (filter) => {
  const { country, state, city, dateRange, gender,utm_payload, isBot, locationStatsType } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
    isBot,
    statsType: locationStatsType
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/location?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
export const fetchDashboardStatsData = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/dashboard?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};

export const fetchDashboardUnreadBotChatStatsData = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/dashboard/unReadBotChatStats?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};

export const fetchDashboardUserSubscription = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;
  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });
  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/userSubscription?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
export const fetchDashboardTopLocation = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/topLocation?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
export const fetchDashboardUserGenderDistribution = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;
  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });
  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getGenderDistribution?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
export const fetchRevenuePlanWise = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getRevenuePlanWise?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
export const getConversionMetrics = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getConversionMetrics?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
export const getAgeDistribution = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getAgeDistribution?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
export const getSignupFunnel = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getSignupFunnel?${queryParams}`,
    isAbort:false
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
/**
 * Options for the global country filter — GET /admin/analytics/stat/countryOptions.
 *
 * Returns [{ country, users, realUsers }] over the WHOLE user base, ordered by real
 * (non-bot) users. Deliberately takes no filter arguments: the list must not narrow
 * itself by the filter it populates, and the endpoint applies no status/date conditions
 * either (see getCountryOptions server-side).
 *
 * The country filter matches EXACTLY server-side, so sourcing the options from the data
 * is what keeps every option selectable — the hardcoded MUI list this replaced carried
 * old ISO long forms ("Tanzania, United Republic of", "Swaziland") that matched nothing.
 */
export const fetchCountryOptions = async () => {
  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/countryOptions`,
    isAbort: false,
  });
  if (!res) return null;
  if (res.status >= 200 && res.status < 300 && res.data) {
    return (res.data.data && res.data.data.countries) || [];
  }
  throw new Error(`Unexpected response code: ${res.status}`);
};
